// import { store } from '../store'
import api from './api.js'
import DefaultHomePage from '@/cfg/default-home-pages'
import { cookies } from '@/util/cookies'
// import router from '@/router'

// MUST BE IN ORDER OF SENIORITY
const roles = Object.freeze({
  LEARNER: 'learner',
  COACH: 'coach',
  ADMIN: 'admin',
  RESELLER: 'reseller',
  RESEARCHER: 'researcher',
  SYSADMIN: 'sysadmin',
  TESTER: 'tester',
  DEVELOPER: 'developer',
  SUPER: 'super',
})

export class Users
{
  static users = undefined
  static dirty = true

  static async Sync () {
    if (!this.users || this.dirty) {
      this.users = await api.getUsers()
      this.dirty = false
    }
  }

  static SetDirty () {
    this.dirty = true
  }

  static GetDisplayName (id) {
    if (!this.users) {
      return 'Anonymous'
    }

    for (let i = 0; i < this.users.length; i++)
    {
      if (this.users[i].id === id) {
        return this.users[i].displayName
      }
    }
    return ''
  }

  static Count () {
    if (!this.users) return -1
    return this.users.length
  }

  static async Get (roleFilter = undefined) {
    await this.Sync()

    if (!roleFilter) {
      return this.users
    } else {
      const filteredUsers = []
      this.users.forEach(x => {
        if (roleFilter.some(role => x.roles.includes(role))) {
          filteredUsers.push(x)
        }
      })
      return filteredUsers
    }
  }
}



export const Roles = {
  ...roles,
  All: Object.values(roles),
  HighestOf (userRoles) {
    const roleValues = Object.values(roles)
    for (let index = roleValues.length - 1; index >= 0; index--) {
      if (userRoles.includes(roleValues[index])) {
        return roleValues[index]
      }
    }
    throw new Error('invalid role ' + userRoles)
  },
}

export const filterSoftDeleteAccounts = (userProfiles) =>
  Object.keys(userProfiles).reduce((acc, key) => {
    if (userProfiles[key].account.softDelete !== true) {
      acc[key] = userProfiles[key]
    }
    return acc
  }, {})

export async function PostAuthUserEmailLoginProcess (user, store, i18n)
{
  store.dispatch('setAuthUserId', user.uid)
  // Request the user profiles if not already there
  // console.log('Fetching profiles for ' + user.uid)
  if (!store.getters.userProfiles) {
    // await store.dispatch('fetchUserProfiles', user.uid)
    await store.dispatch('fetchUserProfilesByEmail', user.email)
  }

  const allProfiles = filterSoftDeleteAccounts(store.getters.userProfiles)

  const originalUrl = cookies.get('toPath')

  // We store the active user profile in a cookie so check if its set
  let currentUserID = cookies.get('currentUserID')
  let currentUserProfile


  if (Object.entries(allProfiles).length === 0) {
    throw new Error('no profiles found')
  }
  // If the user doesn't have a valid currentUserID set and there are multiple ones redirect to the profileSelect screen
  if (Object.entries(allProfiles).length > 1 && !currentUserID) {
    // this.showProfileSelection = true
    // console.log('Redirecting to select profile selection')
    return { path: '/selectProfile' }
  }
  else {
    // Otherwise use the existing profile or select the first profile in the list
    if (!currentUserID || !Object.keys(allProfiles).includes(currentUserID)) {
      currentUserID = Object.keys(allProfiles)[0]
    }
    currentUserProfile = store.getters.userProfiles[currentUserID]
    i18n.locale = currentUserProfile.account.locale ?? 'em'
    // if the account requires MFA
    // if (currentUserProfile.account.isMfaActivated) {
    //   if (user.multiFactor.enrolledFactors.length > 0) {
    //     // Account has MFA activated,user has been multi factored authenicated
    //     cookies.set('currentUserID', currentUserID)
    //     store.commit('SET_CURRENT_USER_PROFILE', currentUserProfile)
    //     return {
    //       path: DefaultHomePage(currentUserProfile.user),
    //     }
    //   } else {
    //     // verify email before adding phone number
    //     //
    //     cookies.set('currentUserID', currentUserID)
    //     store.commit('SET_CURRENT_USER_PROFILE', currentUserProfile)
    //     await api.verifyUserEmail(user.uid)
    //     return { path: `/add-phone-number/${currentUserID}` }
    //   }
    // } else {
      // If the account doesnt require MFA
      cookies.set('currentUserID', currentUserID)
      store.commit('SET_CURRENT_USER_PROFILE', currentUserProfile)
      // console.log('Using user profile ' + currentUserID + ' out of ' + Object.keys(allProfiles).length + ' profiles')
      // re-direct to the relevant page

      cookies.remove('toPath')
      return {
        path: originalUrl || DefaultHomePage(currentUserProfile.user),
      }
    // }
  }
}

export async function PostAuthUserLoginProcess (user, store, i18n)
{
  const isIframe = process.env.VUE_APP_IS_IFRAME && process.env.VUE_APP_IS_IFRAME === 'true'
  // Set authUserId
  store.dispatch('setAuthUserId', user.uid)
  // Request the user profiles if not already there
  // console.log('Fetching profiles for ' + user.uid)
  if (!store.getters.userProfiles) {
    await store.dispatch('fetchUserProfiles', user.uid)
  }

  const allProfiles = filterSoftDeleteAccounts(store.getters.userProfiles)

  // We store the active user profile in a cookie so check if its set
  let currentUserID = isIframe ? cookies.get('user') : cookies.get('currentUserID')
  let currentUserProfile

  const originalUrl = cookies.get('toPath')

  if (Object.entries(allProfiles).length === 0) {
    throw new Error('no profiles found')
  }
  // If the user doesn't have a valid currentUserID set and there are multiple ones redirect to the profileSelect screen
  if (Object.entries(allProfiles).length > 1 && !currentUserID) {
    // this.showProfileSelection = true
    // console.log('Redirecting to select profile selection')
    return { path: '/selectProfile' }
  }
  else {
    // Otherwise use the existing profile or select the first profile in the list
    if (!currentUserID || !Object.keys(allProfiles).includes(currentUserID)) {
      currentUserID = Object.keys(allProfiles)[0]
    }
    currentUserProfile = store.getters.userProfiles[currentUserID]
    i18n.locale = currentUserProfile.account.locale ?? 'en'
   // if the account requires MFA
   if (currentUserProfile.account.isMfaActivated && !isIframe) {
    if (user.multiFactor.enrolledFactors.length > 0) {
      // Account has MFA activated,user has been multi factored authenicated
      cookies.set('currentUserID', currentUserID)
      store.commit('SET_CURRENT_USER_PROFILE', currentUserProfile)
      cookies.remove('toPath')
      return {
        path: originalUrl || DefaultHomePage(currentUserProfile.user),
      }
    } else {
      // verify email before adding phone number
      //
      cookies.set('currentUserID', currentUserID)
      store.commit('SET_CURRENT_USER_PROFILE', currentUserProfile)
      await api.verifyUserEmail(user.uid)
      return { path: `/add-phone-number/${currentUserID}` }
    }
   } else {
    // If the account doesnt require MFA
    cookies.set('currentUserID', currentUserID)
    store.commit('SET_CURRENT_USER_PROFILE', currentUserProfile)
    // console.log('Using user profile ' + currentUserID + ' out of ' + Object.keys(allProfiles).length + ' profiles')
    // re-direct to the relevant page
      cookies.remove('toPath')
      return {
        path: originalUrl || DefaultHomePage(currentUserProfile.user),
      }
   }
  }
}
